<template>
  <div>
    <vx-card title="Список камер" class="p-6">
      <vs-row class="-mx-4">
        <vs-col
          v-for="(camera, index) in cameraList"
          :key="index"
          class="w-full px-4 sm:w-1/2 lg:w-1/3 mb-base"
        >
          <vs-card actionable class="cardx pb-1">
            <div slot="media">
              <iframe
                style="
                  width: 100%;
                  height: auto;
                  min-height: 480px;
                  display: block;
                "
                :src="camera.link"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
            <div>
              <h4>{{ camera.name }}</h4>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>
<script>
import { API_URL, cameraList } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,
    cameraList,
  }),
  components: {},
  watch: {},
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
  },
  created() {},
  mounted() {},
};
</script>